export const DEFAULT_LOCALE = "en-IE";
export const DEFAULT_SYMBOL = "€";
export const TWO_DP_FORMAT_OPTIONS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};
export const ZERO_DP_FORMAT_OPTIONS = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

export const TWO_DECIMAL_PLACES = "TwoDecimalPlaces";
export const NO_DECIMAL_PLACES = "NoDecimalPlaces";

export const DEFAULT_DECIMAL_PLACES = TWO_DECIMAL_PLACES;

export const CURRENCY_FORMATS = [
  TWO_DECIMAL_PLACES,
  NO_DECIMAL_PLACES,
] as const;
